__turbopack_context__.v({
  "container": "OrderTotal-module-scss-module__Lmk2Aa__container",
});
